import { useAction } from "@/hooks/shared";
import { processExamHandler } from "@/services";

export const useProcessExam = () => useAction(processExamHandler);
